import Dexie from "dexie";
import db from "../Db";

var DeletePlan = Dexie.async(function* () {
  yield db.open();
  yield db.PLAN.clear();
});

export default DeletePlan;
